import { lazy } from 'react';

const TutorStatsPage = lazy(() =>
  import('./tutor-stats/page.js').then((module) => ({ default: module.TutorStatsPage })),
);
const TutorSessionsPage = lazy(() =>
  import('./sessions/page.js').then((module) => ({ default: module.TutorSessionsPage })),
);
const TutorSessionDetailPage = lazy(() =>
  import('./sessions/[id]/page.js').then((module) => ({ default: module.TutorSessionDetailPage })),
);

export { TutorSessionDetailPage, TutorSessionsPage, TutorStatsPage };
